import { useEffect, useState } from "react";
import SummaryApi from "../common";
import BannerProduct from "../components/BannerProduct";
import BrandStrip from "../components/BrandStrip";
import BrandTicker from "../components/BrandTicker";
import CategoryList from "../components/CategoryList";
import FeaturedProducts from "../components/FeaturedProducts";
import HomeReviews from "../components/HomeReviews";
import HomeTrustBar from "../components/HomeTrustBar";
import SEO from "../components/SEO";
import SplitPromoBanner from "../components/SplitPromoBanner";
import { HOME_SEO_DESC, HOME_SEO_TITLE } from "../constants";
import { request } from "../helpers/request";

const Home = () => {
  const [brandNames, setBrandNames] = useState([]);
  const fetchBrandNames = async () => {
    try {
      const res = await request(SummaryApi.getBrandsPublic);
      const json = await res.json();
      if (json.success && json.data.length > 0) {
        setBrandNames(json.data.map((b) => b.name));
      } else {
        // Fallback: display known stockist names if API returns empty
        setBrandNames([
          "Shoei",
          "AGV",
          "HJC",
          "Bell",
          "LS2",
          "Alpinestars",
          "Castrol",
          "Motul",
          "NGK",
        ]);
      }
    } catch {
      setBrandNames([
        "Shoei",
        "AGV",
        "HJC",
        "Bell",
        "LS2",
        "Alpinestars",
        "Castrol",
        "Motul",
        "NGK",
      ]);
    }
  };

  useEffect(() => {
    fetchBrandNames();
  }, []);

  return (
    <main className="min-h-screen bg-ds-background">
      <SEO title={HOME_SEO_TITLE} description={HOME_SEO_DESC} />

      {/* 1. Hero Banner ──────────────────────────────────────────────── */}
      <BannerProduct />

      {/* 2. Brand Trust Ticker ──────────────────────────────────────── */}
      <BrandTicker brands={brandNames} />

      {/* 3. Category Strip (dark 6-col image grid) ──────────────────── */}
      <CategoryList />

      {/* 4. Popular Right Now (featured grid + filter chips) ────────── */}
      <FeaturedProducts />

      {/* 5. Split Promotional Banner ────────────────────────────────── */}
      <SplitPromoBanner />

      {/* 6. Shop By Brand (horizontal scroll) ──────────────────────── */}
      <BrandStrip />

      {/* 7. What Riders Say (dynamic reviews) ──────────────────────── */}
      <HomeReviews />

      {/* 8. Trust Bar (black strip) ─────────────────────────────────── */}
      <HomeTrustBar />
    </main>
  );
};

export default Home;
